import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import Dropzone from 'react-dropzone';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import { empty, showNotification } from './../../../utils';

const FormModal = React.memo((props) => {
    const hideHandler = () => {
        props.setIdModal(null);
        props.hideFormModal();
        props.resetForm();
        props.setPdfFile(null);
        props.setPreviewFile(null);
    };

    const onPdfDrop = (acceptedFiles) => {
        props.setPdfFile(acceptedFiles[0]);
    };

    const onPreviewDrop = (acceptedFiles) => {
        props.setPreviewFile(acceptedFiles[0]);
    };

    let previewImage = null;
    if (props.form && props.form.image_url) {
        previewImage = (
            <div className="current-image">
                <div>Current Preview Image:</div>
                <img src={props.form.image_url} alt="" />
            </div>
        );
    }

    let currentPdfLink = null;
    if (props.form && props.form.file_url) {
        currentPdfLink = <div><a href={props.form.file_url} target="_blank" rel="noopener noreferrer">View Current File <i className="fas fa-external-link-alt" /></a></div>;
    }

    let currentPreviewLink = null;
    if (props.form && props.form.image_url) {
        currentPreviewLink = <div><a href={props.form.image_url} target="_blank" rel="noopener noreferrer">View Current Image <i className="fas fa-external-link-alt" /></a></div>;
    }

    const handleFieldChange = (field, event) => {
        props.setFormField(field, event.target.value);
    };

    const renderCategories = () => {
        let options = [];
        for (let i = 0; i < props.departments.length; i++) {
            const element = props.departments[i];

            if (element.platform === '') {
                continue;
            }

            let disabled = false;
            if (parseInt(element.is_last_level) === 0) {
                disabled = true;
            }

            options.push(<option value={element.id} disabled={disabled} className={disabled ? 'disabled-option' : ''}>[{element.platform}] {element.name}</option>);
            renderSubcategories(element, options, 1);
        }

        return options;
    };

    const renderSubcategories = (element, options, level) => {
        let spaces = [];
        for (let i = 0; i < level; i++) {
            spaces.push('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
        }

        for (let i = 0; i < element.subcategories.length; i++) {
            const subcategory = element.subcategories[i];

            let disabled = false;
            if (parseInt(subcategory.is_last_level) === 0) {
                disabled = true;
            }

            options.push(<option value={subcategory.id} dangerouslySetInnerHTML={{
                __html: spaces.join('') + subcategory.name
            }} disabled={disabled} className={disabled ? 'disabled-option' : ''}></option>);

            renderSubcategories(subcategory, options, level + 1);
        }
    };

    const renderSelectedDepartments = () => {
        if (!props.form.departments_ids) {
            return null;
        }

        return props.form.departments_ids.map((id, index) => {
            let department = null;
            for (let i = 0; i < props.allDepartments.length; i++) {
                if (parseInt(id) === parseInt(props.allDepartments[i].id)) {
                    department = props.allDepartments[i];
                    break;
                }
            }

            if (department == null) {
                return null;
            }

            return (
                <div className="department">{department.name} <i className="fas fa-trash" onClick={props.deleteDepartment.bind(this, index)} /></div>
            );
        });
    };

    const handleAddDepartment = () => {
        if (empty(props.form.department_id)) {
            return showNotification('Select department', 'Select a department', 'info');
        }

        for (let i = 0; i < props.form.departments_ids.length; i++) {
            if (parseInt(props.form.department_id) === parseInt(props.form.departments_ids[i])) {
                return showNotification('Existing Department', 'This department has been added already', 'info');
            }
        }

        props.addDepartment(props.form.department_id);
    };

    let buttonLabel = 'Save';
    if (props.saving) {
        buttonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    let actions = [
        <button key="save-button" className="btn btn-light btn-sm action-button" onClick={props.saveForm}>{buttonLabel}</button>,
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Close</button>
    ];
    return (
        <Dialog
            name="form-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="admin-forms-form-modal-dialog"
        >
            <div className="admin-forms-form-modal-container">
                <div className="title">Form</div>
                <div className="subtitle">Information</div>
                <div className="info-fields">
                    <div className="field sku-field">
                        <div className="label">SKU <span className="required">*</span>:</div>
                        <input type="text" value={props.form.sku} onChange={handleFieldChange.bind(this, 'sku')} />
                    </div>
                    <div className="field name-field">
                        <div className="label">Name <span className="required">*</span>:</div>
                        <input type="text" value={props.form.name} onChange={handleFieldChange.bind(this, 'name')} />
                    </div>
                    <div className="field department-field">
                        <div className="label">Department <span className="required">*</span>:</div>
                        <select value={props.form.uthealth_department_id} onChange={handleFieldChange.bind(this, 'uthealth_department_id')}>
                            <option value="">Select option</option>
                            {props.departments.map((department) => {
                                return <option key={department.id} value={department.id}>{department.name}</option>
                            })}
                        </select>
                    </div>
                    <div className="small-field">
                        <div className="label">Pieces Per <span className="required">*</span>:</div>
                        <input type="text" value={props.form.pieces_per} onChange={handleFieldChange.bind(this, 'pieces_per')} />
                    </div>
                    <div className="small-field">
                        <div className="label">Width <span className="required">*</span>:</div>
                        <input type="text" value={props.form.width} onChange={handleFieldChange.bind(this, 'width')} />
                    </div>
                    <div className="small-field">
                        <div className="label">Height <span className="required">*</span>:</div>
                        <input type="text" value={props.form.height} onChange={handleFieldChange.bind(this, 'height')} />
                    </div>
                    <div className="small-field">
                        <div className="label">Pages <span className="required">*</span>:</div>
                        <input type="text" value={props.form.pages} onChange={handleFieldChange.bind(this, 'pages')} />
                    </div>
                    <div className="small-field">
                        <div className="label">Shipping Charge <span className="required">*</span>:</div>
                        <input type="text" value={props.form.shipping_charge} onChange={handleFieldChange.bind(this, 'shipping_charge')} />
                    </div>
                    <div className="small-field">
                        <div className="label">
                            Price/Bundle:
                            <Tooltip title="The Price/Bundle field is optional, just enter a value if you want to use a fixed Price/Bundle instead of the main Pricing schema. Otherwise leave it blank." position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <input type="text" value={props.form.unit_cost1} onChange={handleFieldChange.bind(this, 'unit_cost1')} />
                    </div>
                    <div className="field printing-field">
                        <div className="label">
                            Display Printing Field <span className="required">*</span>:
                            <Tooltip title={'If you enable this option, a dropdown with the options "Black and White" and "Color" will be presented, if not the Black and White option will be default with no dropdown.'} position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.form.use_printing_option} onChange={handleFieldChange.bind(this, 'use_printing_option')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                </div>
                <hr />
                <div className="subtitle departments-subtitle">
                    <div>Departments</div>
                    <div className="department-field">
                        <select value={props.form.department_id} onChange={handleFieldChange.bind(this, 'department_id')}>
                            <option value="">Select department</option>
                            {renderCategories()}
                        </select>
                        <button onClick={handleAddDepartment}>Add</button>
                    </div>
                </div>
                <div className="departments-list">{renderSelectedDepartments()}</div>
                <hr />
                <div className="subtitle">Files</div>
                <div className="file-fields">
                    <div className="dropzones">
                        <Dropzone onDrop={onPdfDrop} accept=".pdf">
                            {({ getRootProps, getInputProps }) => (
                                <div className="pdf-dropzone-container">
                                    <div className="label">
                                        PDF File <span className="required">*</span>:
                                        <Tooltip title="The high resolution PDF file that will be used for this Form" position="top" arrow size="small" className="info-tooltip">
                                            <i className="fas fa-question-circle" />
                                        </Tooltip>
                                    </div>
                                    <div {...getRootProps()} className="button">
                                        <input {...getInputProps()} />
                                        <p>Click here to upload a file</p>
                                    </div>
                                    {currentPdfLink}
                                    <div className="file-name">
                                        {props.pdfFile != null ? <Fragment><b>Selected File:</b> {props.pdfFile.name}</Fragment> : null}
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                        <Dropzone onDrop={onPreviewDrop} accept="image/png, image/jpg, image/jpeg">
                            {({ getRootProps, getInputProps }) => (
                                <div className="preview-dropzone-container">
                                    <div className="label">
                                        Preview Image <span className="required">*</span>:
                                        <Tooltip title="The Preview image that will be displayed in the tile of the Form. It needs to be a PNG or JPG image, with a preferable size of 200px wide. No restriction in height but 200px recommended also." position="top" arrow size="small" className="info-tooltip">
                                            <i className="fas fa-question-circle" />
                                        </Tooltip>
                                    </div>
                                    <div {...getRootProps()} className="button">
                                        <input {...getInputProps()} />
                                        <p>Click here to upload a file</p>
                                    </div>
                                    {currentPreviewLink}
                                    <div className="file-name">
                                        {props.previewFile != null ? <Fragment><b>Selected File:</b> {props.previewFile.name}</Fragment> : null}
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                    </div>
                    {previewImage}
                </div>
                <div className="subtitle">Information Bullets</div>
                <div className="description-fields">
                    <div className="field">
                        <div className="label">Bullet 1:</div>
                        <input type="text" value={props.form.description1} onChange={handleFieldChange.bind(this, 'description1')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 2:</div>
                        <input type="text" value={props.form.description2} onChange={handleFieldChange.bind(this, 'description2')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 3:</div>
                        <input type="text" value={props.form.description3} onChange={handleFieldChange.bind(this, 'description3')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 4:</div>
                        <input type="text" value={props.form.description4} onChange={handleFieldChange.bind(this, 'description4')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 5:</div>
                        <input type="text" value={props.form.description5} onChange={handleFieldChange.bind(this, 'description5')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 6:</div>
                        <input type="text" value={props.form.description6} onChange={handleFieldChange.bind(this, 'description6')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 7:</div>
                        <input type="text" value={props.form.description7} onChange={handleFieldChange.bind(this, 'description7')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 8:</div>
                        <input type="text" value={props.form.description8} onChange={handleFieldChange.bind(this, 'description8')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 9:</div>
                        <input type="text" value={props.form.description9} onChange={handleFieldChange.bind(this, 'description9')} />
                    </div>
                    <div className="field">
                        <div className="label">Bullet 10:</div>
                        <input type="text" value={props.form.description10} onChange={handleFieldChange.bind(this, 'description10')} />
                    </div>
                </div>
                <div className="subtitle">Permissions</div>
                <div className="permission-fields">
                    <div className="field">
                        <div className="label">
                            Show for UTP <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form in the UTP platform for Admins, Regular Users and Approvers" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.form.allow_utp} onChange={handleFieldChange.bind(this, 'allow_utp')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="field">
                        <div className="label">
                            Show for UTH <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form in the UTH platform for Admins, Regular Users and Approvers" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.form.allow_uth} onChange={handleFieldChange.bind(this, 'allow_uth')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="field">
                        <div className="label">
                            Show for Manager <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form in the Managers section" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.form.allow_manager} onChange={handleFieldChange.bind(this, 'allow_manager')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="field">
                        <div className="label">
                            Show for Personal <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form in the Personal Purchases platform" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.form.allow_personal} onChange={handleFieldChange.bind(this, 'allow_personal')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div className="field">
                        <div className="label">
                            Show for Coupa <span className="required">*</span>:
                            <Tooltip title="This field controls the visibility of this Form for the users coming from Coupa" position="top" arrow size="small" className="info-tooltip">
                                <i className="fas fa-question-circle" />
                            </Tooltip>
                        </div>
                        <select value={props.form.allow_coupa} onChange={handleFieldChange.bind(this, 'allow_coupa')}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                </div>
            </div>
        </Dialog >
    );
});

export default FormModal;
